// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__DAO_7","signatureBlock":"Footer_signatureBlock__56ZeG","signature":"Footer_signature___kOch"};